const types = ["None", "Long text", "Short text", "Number", "Date"];

export function questionAnswerSettings(description = "") {
  const type = String(description).match(/^Answer type:\s*([^\r\n]*)/im)?.[1]?.trim();
  return {
    answerType: types.find((item) => item.toLowerCase() === type?.toLowerCase()) || "Yes / No / N/A",
    answerRequired: /^Required:\s*Yes\s*$/im.test(description),
  };
}

export function initialQuestionAnswer(question) {
  if (question?.answerType === "None") return "";
  if (question?.answerType && question.answerType !== "Yes / No / N/A") return question.response || "";
  return question?.response === "not applicable" ? "na" : question?.response || "yes";
}
